"use strict";

// observer.js
(() => {
  const init = () => {
    // 汎用アニメーション
    const selectors = [".u-animation--fadeIn", ".u-animation--appear", ".u-animation--scale"];

    const targets = document.querySelectorAll(selectors.join(", "));
    if (!targets.length) return;

    // 非対応環境では常時表示にフォールバック
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("js-show"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("js-show");
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -10% 0px", // 画面下端から10%上を発火ラインにする
        threshold: 0, // 1pxでも入ったら発火（要素の高さに依存しない）
      }
    );

    targets.forEach((el) => observer.observe(el));
  };

  // load だと外部リソース待ちで発火が遅れるため DOMContentLoaded で開始
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

